import type { CompareContent } from "@/lib/compare/types";

import { AUTOSHORTS_CONTENT } from "./autoshorts";
import { CAPCUT_CONTENT } from "./capcut";
import { CAPTIONS_AI_CONTENT } from "./captions-ai";
import { CLIPCHAMP_CONTENT } from "./clipchamp";
import { CLIPPIE_CONTENT } from "./clippie";
import { DESCRIPT_CONTENT } from "./descript";
import { EKLIPSE_CONTENT } from "./eklipse";
import { FACELESS_VIDEO_CONTENT } from "./faceless-video";
import { KAPWING_CONTENT } from "./kapwing";
import { KLAP_CONTENT } from "./klap";
import { OPUS_CLIP_CONTENT } from "./opus-clip";
import { QUSO_CONTENT } from "./quso";
import { REVID_CONTENT } from "./revid";
import { RIVERSIDE_CONTENT } from "./riverside-magic-clips";
import { SENDSHORT_CONTENT } from "./sendshort";
import { STORYSHORT_CONTENT } from "./storyshort";
import { STREAMLADDER_CONTENT } from "./streamladder";
import { SUBMAGIC_CONTENT } from "./submagic";
import { SYLLABY_CONTENT } from "./syllaby";
import { VEED_CONTENT } from "./veed";
import { VIZARD_CONTENT } from "./vizard";
import { VSUB_CONTENT } from "./vsub";

export const COMPARE_CONTENT: CompareContent[] = [
  OPUS_CLIP_CONTENT,
  CAPCUT_CONTENT,
  SUBMAGIC_CONTENT,
  VIZARD_CONTENT,
  CAPTIONS_AI_CONTENT,
  KLAP_CONTENT,
  EKLIPSE_CONTENT,
  REVID_CONTENT,
  AUTOSHORTS_CONTENT,
  VEED_CONTENT,
  DESCRIPT_CONTENT,
  STREAMLADDER_CONTENT,
  QUSO_CONTENT,
  SENDSHORT_CONTENT,
  STORYSHORT_CONTENT,
  FACELESS_VIDEO_CONTENT,
  SYLLABY_CONTENT,
  RIVERSIDE_CONTENT,
  KAPWING_CONTENT,
  CLIPCHAMP_CONTENT,
  VSUB_CONTENT,
  CLIPPIE_CONTENT,
];

export const COMPARE_CONTENT_MAP: Record<string, CompareContent> = Object.fromEntries(
  COMPARE_CONTENT.map((content) => [content.slug, content]),
);
